const style = {
  
  
  pageHeadingWrapper: {
    margin: "24px 0 40px 48px",
    position: "relative",
  },
  pageHeading: {
    color: "black",
    fontSize: 24,
    fontWeight: 500,
    letterSpacing: 0.08,
  },
  pageHeadingCaption: {
    color: "grey.500",
    fontFamily: "regular",
    fontSize: 12,
    letterSpacing: 0.17,
  },
  actionWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "8px 15px 24px 43px",
    borderBottom: `1px solid grey`,
  },
  pageHeadingMarker: {
    background: "#7f5bdb",
    height: 70,
    width: 4,
    position: "absolute",
    left: -24,
    top: 0,
  },
  tablePaper: {
    "border-radius": "10px",
    "max-height": "600px !important",
  },
};
export default style;
